<script>
  import PdfPreviewInternal from './previews/PdfPreview.svelte';

  export let url;
  export let name = '';
  export let size = '';
  export let mime = '';
  export let onOpen;
</script>

<PdfPreviewInternal {url} {name} {size} {mime} {onOpen} />
